import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { I18nProvider } from "./i18n/I18nProvider";
import Header from "./sections/Header";
import Hero from "./sections/Hero";
import About from "./sections/About";
import Categories from "./sections/Categories";
import Specials from "./sections/Specials";
import Gallery from "./sections/Gallery";
import Visit from "./sections/Visit";
import Contact from "./sections/Contact";
import Footer from "./sections/Footer";

const Home = () => {
  return (
    <main data-testid="home-page">
      <Header />
      <Hero />
      <About />
      <Categories />
      <Specials />
      <Gallery />
      <Visit />
      <Contact />
      <Footer />
    </main>
  );
};

function App() {
  return (
    <div className="App">
      <I18nProvider>
        <Toaster
          position="top-center"
          richColors
          closeButton
          toastOptions={{ style: { fontFamily: "Karla, sans-serif" } }}
        />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </BrowserRouter>
      </I18nProvider>
    </div>
  );
}

export default App;
